import { API } from '.';

class CompanyService {
    async sendReport(companyId, email) {
        const response = await API.post('/api/companies/weekly-report', {
            data: {
                email,
                companyId,
            },
        });
        return response.data;
    }

    async update(companyId, data = {}) {
        const response = await API.put(`/api/companies/${companyId}`, {
            data,
        });
        return response.data;
    }
}

export default CompanyService;
